import { findDetailedPunctualityReports } from '@src/main/modules/reports/punctuality/application/use-cases/find-detailed-punctuality-reports.usecase';
import { createPunctualityReportHttpRepository } from '@src/main/modules/reports/punctuality/infrastructure/repository/PunctualityReportHttpRepository';
import {
  PunctualityDetail,
  PunctualityReportCriteria,
} from '@src/main/modules/reports/shared/domain/report.interface';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDetailedPunctualityReports = (criteria: PunctualityReportCriteria) => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createPunctualityReportHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useQuery<PunctualityDetail[], Error>({
    queryKey: ['punctualityDetailedReports', JSON.stringify(criteria)],
    queryFn: async () => {
      if (!repository) return [];
      return await findDetailedPunctualityReports(repository, criteria);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });
};
